import firebase from 'firebase/app'
import 'firebase/firestore'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyB8g4ssM4zP-rU39-vUKCgzsWo2IZMb4iU",
    authDomain: "r42-vue-test.firebaseapp.com",
    databaseURL: "https://r42-vue-test.firebaseio.com",
    projectId: "r42-vue-test",
    storageBucket: "r42-vue-test.appspot.com",
    messagingSenderId: "292744498059"
};
firebase.initializeApp(config);

const db = firebase.firestore()
export default db



  
